export enum AssessmentCategory{
	PRIMATOO = 'PRIMATOO',
	SUPPLIER = 'SUPPLIER',
	INTERNAL = 'INTERNAL',
	NOT_AVAILABLE = 'NOT_AVAILABLE',
	NOT_SUPPORTED = 'NOT_SUPPORTED',
}
